<div class="mi-recaptcha-error-page d-flex flex-column align-items-center">
    <div>
        <img src="assets/images/general/error/reCaptchaErrorPage.svg" alt="recaptcha error page">
    </div>
    <div>
        <p class="fw-bold">{{errorText?.recaptchErrorPage?.text}}</p>
    </div>
    <div>
        <small>{{errorText?.recaptchErrorPage?.smallText}}</small>
    </div>
</div>